<div class="flex w-full" [ngClass]="OtpFromModal ? 'min-h-0' : 'h-screen'">
  <div
    class="flex w-full flex-col bg-white"
    [ngClass]="OtpFromModal ? '' : 'md:w-1/2'"
  >
    <app-logo-header *ngIf="!OtpFromModal"></app-logo-header>

    <div
      class="flex flex-1 justify-center"
      [ngClass]="OtpFromModal ? 'py-2' : ''"
    >
      <div
        class="w-full px-6"
        [ngClass]="OtpFromModal ? 'max-w-[480px]' : 'max-w-[420px]'"
      >
        <button
          type="button"
          class="text-sm text-gray-600 mb-4 hover:text-gray-900"
          (click)="goBack()"
        >
          ← Back to login
        </button>

        <h1
          class="text-gray-900 pb-3 text-center"
          [ngClass]="
            OtpFromModal ? 'text-2xl pt-2' : 'text-xl md:text-4xl pt-6 md:pt-12'
          "
        >
          Enter verification code
        </h1>

        <p class="text-md text-gray-600 text-center pb-2">
          We sent a 6-digit verification code to
        </p>

        <p class="text-sm font-semibold text-gray-900 text-center pb-8">
          {{ email }}
        </p>

        <form (submit)="handleSubmit($event)" class="flex flex-col gap-6">
          <div
            class="flex justify-center gap-2 md:gap-3"
            (paste)="handlePaste($event)"
          >
            <input
              *ngFor="let digit of otp; let i = index; trackBy: trackByIndex"
              [id]="'otp-input-' + i"
              type="text"
              inputmode="numeric"
              maxlength="1"
              autocomplete="one-time-code"
              [value]="otp[i]"
              (input)="handleInputChange(i, $event)"
              (keydown)="handleKeyDown(i, $event)"
              class="w-11 h-12 md:w-12 md:h-14 text-center text-xl font-semibold border-2 border-gray-200 rounded-xl focus:outline-none focus:border-purple-500"
            />
          </div>

          <p *ngIf="errorMessage" class="text-red-500 text-sm text-center">
            {{ errorMessage }}
          </p>

          <button
            type="submit"
            class="w-full px-6 py-3 shadow rounded-3xl text-white"
            [ngClass]="
              isLoading || !isComplete
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-gray-950'
            "
            [disabled]="isLoading || !isComplete"
          >
            {{ isLoading ? "Verifying..." : "Verify and continue" }}
          </button>
        </form>

        <div class="pt-5 text-center">
          <span class="text-sm text-gray-600"> Didn't receive the code? </span>

          <button
            type="button"
            class="ml-1 text-sm font-semibold text-gray-900"
            (click)="resendOtp()"
            [disabled]="isLoading"
          >
            Resend code
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!OtpFromModal"
    class="hidden md:flex relative w-1/2 items-end bg-cover bg-center text-white p-10"
    [style.background-image]="'url(' + assetUrl + 'img/login-img.jpg)'"
  >
    <div
      class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-0"
    ></div>

    <div class="w-full max-w-[600px] relative z-10">
      <h2 class="text-6xl mb-4 text-white">Almost there</h2>

      <p class="mb-6 text-lg text-white">
        Verify your code to securely continue to your gloget account.
      </p>
    </div>
  </div>
</div>
